import { render, staticRenderFns } from "./Aboutpage.vue?vue&type=template&id=00ed312c"
import script from "./Aboutpage.vue?vue&type=script&lang=js"
export * from "./Aboutpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports